import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import DONE from '../../../assets/images/base/done.png';
import { Page } from '../../../helbest';
import { _Cart_Clean } from '../../../store/actions/cart_actions';

const BankDone = ({ Login, history, dispatch, match }) => {
  const check_user = () => {
    if (!Login.is_login) {
      history.push('/');
    }
  };

  useEffect(() => {
    check_user();
    dispatch(_Cart_Clean());
  }, []); // eslint-disable-line

  return (
    <Page
      address="/"
      back={true}
      className="page-bank"
      headerFix
      logo
      mobileContainer
      showFooter
      title="نتیجه پرداخت">
      <div className="container desktop-mode succesful-component">
        <div className="box-page">
          <div className="text-center">
            <img alt="" className="payment-img" src={DONE} />
            <h3>سفارش شما ثبت شد</h3>
          </div>
          <p>شماره سفارش: {match.params.code}</p>
          <Link
            className="mt-2 btn btn-block btn-round btn-red w-100"
            to={`/order/${match.params.code}/`}>
            مشاهده سفارش
          </Link>
        </div>
      </div>
    </Page>
  );
};

const mstp = (state) => ({
  Login: state.Login,
  Cart: state.Cart
});
export default connect(mstp)(BankDone);
